import './ConfirmDeletePopUp.css'

function ConfirmDeletePopUp(props) {

    const { file, isOpen, setIsOpen, removeFile, currentPath } = props

    if (isOpen === false) {
        return ''
    }
    else {
        return <>
            <div className={isOpen===true?'popup__container':''}>
                <div className="popup-messagebox">
                    <h1>Confirm Delete !</h1>
                    <p>Deleting <span>{file.key!=null?file.key.slice(currentPath.length):file}</span> cannot be undone</p>
                    <div className="popup-buttons">
                        <button className='buttons' id='cancel' onClick={() => { setIsOpen(false) }}>Cancel</button>
                        <button className='buttons' id='delete' onClick={() => { removeFile() }}>Delete</button>
                    </div>
                </div>
            </div>
        </>
    }

}

export default ConfirmDeletePopUp